import { render, staticRenderFns } from "./UpdateCustomerSalesQuotePopUp.vue?vue&type=template&id=3288c984&scoped=true&"
import script from "./UpdateCustomerSalesQuotePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerSalesQuotePopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerSalesQuotePopUp.vue?vue&type=style&index=0&id=3288c984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288c984",
  null
  
)

export default component.exports